import { useQuery } from "@tanstack/react-query";
import { Datanode } from "@graylog/server-api";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
const DATANODE_CONFIGURED_QUERY_KEY = ["datanode", "configured"];
const STALE_TIME_MS = 3e5;
const useRunsWithDataNode = ({ enabled = true } = {}) => {
  const { permissions } = useCurrentUser();
  const { data, isLoading } = useQuery({
    queryKey: DATANODE_CONFIGURED_QUERY_KEY,
    queryFn: () => Datanode.runsWithDataNode({ requestShouldExtendSession: false }),
    enabled: enabled && isPermitted(permissions, "datanode:read"),
    staleTime: STALE_TIME_MS
  });
  return { data, isLoading };
};
export default useRunsWithDataNode;
